module.exports = __webpack_public_path__ + "img/a6d99e6.jpg";